package com.rainbowclubs.rainbow.domain.use_cases.login

import com.rainbowclubs.rainbow.data.cache.AuthCache
import com.rainbowclubs.rainbow.data.cache.BearerTokenCache
import com.rainbowclubs.rainbow.data.cache.ClubCache
import dev.gitlive.firebase.auth.FirebaseAuth

class LogOutUseCase(
    private val auth: FirebaseAuth,
    private val authCache: AuthCache,
    private val clubCache: ClubCache,
    private val bearerTokenCache: BearerTokenCache,
) {
    suspend operator fun invoke(): Result<Unit> {
        return try {
            auth.signOut()
            Result.success(Unit)
        } catch (e: Exception) {
            Result.failure(e)
        } finally {
            bearerTokenCache.clear()
            authCache.clear()
            clubCache.clear()
        }
    }
}
